var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ConfirmationModal",
    {
      key: _vm.componentKey,
      attrs: {
        entity: _vm.apiTokenToDelete.apiToken,
        title: _vm.$t("DELETE_MODAL_TITLE"),
        "confirm-action-text": _vm.$t("DELETE"),
        "confirm-button-loading": _vm.isLoading
      },
      on: {
        confirm: function($event) {
          return _vm.onConfirmModal()
        },
        close: function($event) {
          return _vm.onCloseDeleteModal()
        },
        dismiss: function($event) {
          return _vm.onCloseDeleteModal()
        }
      }
    },
    [
      !_vm.apiTokenToDelete.references.hasReference
        ? _c("div", [
            _c("div", [
              _c("div", {
                staticClass: "loader-container size-sm",
                attrs: { "bs-loading-overlay": "" }
              }),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "NONE_USAGE_TEXT.THE_API_ACCESS_TOKEN",
                    expression: "'NONE_USAGE_TEXT.THE_API_ACCESS_TOKEN'"
                  }
                ]
              }),
              _c("strong", [_vm._v(_vm._s(_vm.apiTokenName))]),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "NONE_USAGE_TEXT.HAS_NOT_BEEN_USED",
                    expression: "'NONE_USAGE_TEXT.HAS_NOT_BEEN_USED'"
                  }
                ]
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.apiTokenToDelete.references.hasReference
        ? _c("div", [
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "WITH_USAGE_TEXT.ARE_YOU_SURE_YOU_WANT_TO_DELETE",
                  expression:
                    "'WITH_USAGE_TEXT.ARE_YOU_SURE_YOU_WANT_TO_DELETE'"
                }
              ]
            }),
            _c("strong", [_vm._v(_vm._s(_vm.apiTokenName))]),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "WITH_USAGE_TEXT.HAS_BEEN_LAST_USED_ON",
                  expression: "'WITH_USAGE_TEXT.HAS_BEEN_LAST_USED_ON'"
                }
              ]
            }),
            _vm._v(" "),
            _c("div", { staticClass: "well well-sm m-t-10 m-b-0" }, [
              _c("div", { staticClass: "form-horizontal references-list" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", [
                    _c(
                      "ul",
                      {
                        staticClass:
                          "list-unstyled form-control-static list-text-overflow"
                      },
                      [
                        _c("li", [
                          _c("span", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "DATE_TIME",
                                expression: "'DATE_TIME'"
                              }
                            ]
                          }),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.apiTokenUsageLoginTime))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "RESOURCE",
                                expression: "'RESOURCE'"
                              }
                            ]
                          }),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.apiTokenUsageResource))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "IP",
                                expression: "'IP'"
                              }
                            ]
                          }),
                          _c("strong", [_vm._v(_vm._s(_vm.apiTokenUsageIP))])
                        ])
                      ]
                    )
                  ])
                ])
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }